import Vue from "vue";
let currentRequest = 0;

const ServiceService = {
  async fetchOne(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.find("service", id, {
        include: "tenant,links"
      });
      return data.data[0];
    } catch (error) {
      console.log("fetchOne error: ", error);
      return { error: error };
    }
  },
  async fetchAll(searchFilterPagination) {
    try {
      const request = ++currentRequest;
      console.log(`[${request}] START SERVICE `, searchFilterPagination.search);
      const res = await Vue.$jsonApi.findAll(
        "services",
        searchFilterPagination
      );
      if (request !== currentRequest) {
        console.log(`[${request}] SERVICE DISCARDED`);
        return null;
      }
      console.log(`[${request}] END SERVICE `, searchFilterPagination.search);
      return res;
    } catch (error) {
      console.log("fetchAll error: ", error);
      return { error: error };
    }
  },
  async createOrUpdate(payload) {
    try {
      if (payload.id == "" || payload.id == null) {
        return await Vue.$jsonApi.create("service", payload);
      } else {
        return await Vue.$jsonApi.update("service", payload);
      }
    } catch (error) {
      console.log("createOrUpdate error: ", error);
      return { error: error };
    }
  },
  async delete(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.destroy("service", id);
      return data;
    } catch (error) {
      console.log("delete error: ", error);
      return { error: error };
    }
  }
};

export { ServiceService };
